import React from 'react';

import './empty-data-placeholder.less';

export const DirectoryEmptyDataPlaceholder = () => (
    <div className="empty-data-content">
        Нет данных
    </div>
);
